import { render, staticRenderFns } from "./LastGamesWidget.vue?vue&type=template&id=4ae39bf7&"
import script from "./LastGamesWidget.vue?vue&type=script&lang=js&"
export * from "./LastGamesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports